var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlineEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4249 11.2963C41.4249 9.22525 39.7304 7.53076 37.6594 7.53076H7.53507C5.46402 7.53076 3.76953 9.22525 3.76953 11.2963V33.8895C3.76953 35.9606 5.46402 37.6551 7.53507 37.6551H37.6594C39.7304 37.6551 41.4249 35.9606 41.4249 33.8895V11.2963ZM37.6594 11.2963L22.5972 20.7101L7.53507 11.2963H37.6594ZM37.6594 33.8895H7.53507V15.0618L22.5972 24.4757L37.6594 15.0618V33.8895Z",
    fill: "#311B5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineEmail);
export default __webpack_public_path__ + "static/media/ic_outline-email.6f7d069ed61f649bf962236b9799ff86.svg";
export { ForwardRef as ReactComponent };